import React, { CSSProperties, ReactNode } from 'react'

import * as S from './CustomCell.styles'
import { HEADER_CHILDREN_MIN_WIDTH } from './CustomHeader.styles'

interface Props {
  children: ReactNode
  style?: CSSProperties
  // noRightPadding should be true when there's NO custom header children
  // this padding is used to align column content with header label
  noRightPadding?: boolean
  dataCy?: string
}

export const CustomCell = ({ children, style, noRightPadding, dataCy }: Props): JSX.Element => {
  return (
    <S.Container
      data-cy={dataCy}
      style={{ ...style, paddingRight: noRightPadding ? 0 : HEADER_CHILDREN_MIN_WIDTH }}
    >
      {children}
    </S.Container>
  )
}
